function adjust_delivery_time() {
  var delivery_time = 72; // Nombre moyen d'heures pour être livré
  var now = new Date();
  var delivery_date = new Date();

  // Si on est le jeudi après 10h
  if (delivery_date.getDay() === 4 && delivery_date.getHours() >= 10) {
    delivery_date = addHours(delivery_date, 48);
  }

  // Si on est un samedi ou dimanche, on repousse au lundi suivant
  if (now.getDay() === 6 || now.getDay() === 0) {
    var nb_weekend_day = now.getDay() === 6 ? 2 : 1;
    delivery_date = addHours(delivery_date, nb_weekend_day * 24);
  }

  delivery_date = addHours(delivery_date, delivery_time); // Jour de livraison supposé, hors jour chômés

  // Si on tombe sur une date de livraison un dimanche, on ajoute 24h.
  if (delivery_date.getDay() === 0) {
    delivery_date = addHours(delivery_date, 24);
  }

  // Affichage
  var numero_jour_livraison = delivery_date.getDate();
  var nom_jour_livraison = delivery_date.toLocaleDateString("fr-FR", { weekday: 'long' });
  var nom_mois_livraison = delivery_date.toLocaleDateString("fr-FR", { month: 'long' });

  var deliveryElem = document.querySelector(".estimated_delivery span");
  if (deliveryElem) {
    deliveryElem.textContent = `${nom_jour_livraison} ${numero_jour_livraison} ${nom_mois_livraison}`;
  }

  var estimatedDelivery = document.querySelector(".estimated_delivery");
  if (estimatedDelivery) {
    estimatedDelivery.style.display = "block";
  }
}

// Ajoute h Heures à une date existante
function addHours(date, h) {
  return new Date(date.getTime() + h * 60 * 60 * 1000);
}

// Mise à jour de la date de livraison
if (document.querySelector(".estimated_delivery span")) {
  adjust_delivery_time();
}
